import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=30068336&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=ts&"
export * from "./CampaignSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&id=30068336&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30068336",
  null
  
)

export default component.exports